import { useState, useEffect } from 'react';

const LOGO_URL = 'https://public.readdy.ai/ai/img_res/799c7934-df4f-4f20-8337-ef55c5936285.png';

const navLinks = [
  { label: '제품 소개', href: '#products' },
  { label: '특징', href: '#features' },
  { label: '구매', href: '#purchase' },
  { label: '리뷰', href: '#reviews' },
  { label: '브랜드 스토리', href: '#brand' },
  { label: '회원가입', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#FAFAF8] border-b border-[#E8E0D4]' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between h-16 md:h-20 lg:h-28">
        <a href="#" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="cursor-pointer">
          <img
            src={LOGO_URL}
            alt="위딘 로고"
            className={`h-12 md:h-16 lg:h-20 w-auto object-contain transition-all duration-300 ${
              scrolled ? '' : 'brightness-0 invert drop-shadow-lg'
            }`}
            style={{ filter: scrolled ? 'none' : 'brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}
          />
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNavClick(link.href)}
                className={`text-lg font-semibold tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-[#2C2825] hover:text-[#8B7355]'
                    : 'text-white hover:text-[#C4A882]'
                }`}
                style={!scrolled ? { textShadow: '0 2px 8px rgba(0,0,0,0.8), 0 1px 3px rgba(0,0,0,0.6)' } : {}}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* 구매하기 CTA 버튼 (desktop) */}
        <button
          onClick={() => handleNavClick('#purchase')}
          className={`hidden lg:flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap ${
            scrolled
              ? 'bg-[#8B7355] text-white hover:bg-[#7A6245]'
              : 'bg-white/15 text-white border border-white/50 hover:bg-white/25 backdrop-blur-sm'
          }`}
        >
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-shopping-bag-line text-sm"></i>
          </div>
          지금 구매하기
        </button>

        <button
          className={`lg:hidden cursor-pointer ${scrolled ? 'text-[#2C2825]' : 'text-white'}`}
          style={!scrolled ? { textShadow: '0 2px 6px rgba(0,0,0,0.8)' } : {}}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-2xl md:text-3xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-[#FAFAF8] border-t border-[#E8E0D4] px-6 py-4">
          {/* 구매하기 CTA 버튼 (mobile) */}
          <button
            onClick={() => handleNavClick('#purchase')}
            className="flex items-center justify-center gap-2 w-full py-3 mb-3 bg-[#8B7355] text-white text-sm font-semibold rounded-xl cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </div>
            지금 구매하기
          </button>
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left py-3 text-[#2C2825] text-sm font-medium border-b border-[#F0EBE3] last:border-0 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
